import { useEffect } from 'react';

import { addOrUpdateFormField } from '../store/applicationform';
import { useAppDispatch } from './hooks';

const useFieldToggle = (isSelected: boolean, fieldNames: string[]) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isSelected) {
            fieldNames.forEach((fieldName) =>
                dispatch(
                    addOrUpdateFormField({ fieldName, value: undefined, hasError: false, errorMessage: undefined }),
                ),
            );
        }
    }, [isSelected]);
};

export default useFieldToggle;
